const timeZones = [
  {
    id: 5,
    name: 'Alaska',
    abbr: 'AT',
    timeZoneId: 'AST',
    isDisabled: 0
  },
  {
    id: 2,
    name: 'Central',
    abbr: 'CT',
    timeZoneId: 'CST',
    isDisabled: 0
  },
  {
   id: 1,
   name: 'Eastern',
   abbr: 'ET',
   timeZoneId: 'EST',
   isDisabled: 0
 },
 {
  id: 6,
  name: 'Hawaii',
  abbr: 'HT',
  timeZoneId: 'HST',
  isDisabled: 0
 },
 {
   id: 3,
   name: 'Mountain',
   abbr: 'MT',
   timeZoneId: 'MST',
   isDisabled: 0
 },
 {
   id: 4,
   name: 'Pacific',
   abbr: 'PT',
   timeZoneId: 'PST',
   isDisabled: 0
 }
];

export default timeZones;
